import { useEffect } from 'react';

export const useVersionLogging = (appName: string) => {
  useEffect(() => {
    const style = 'color: #003f35; background:#eee;  font-size:12px;';
    const version = import.meta.env.VITE_APP_VERSION || 'unknown';
    console.log(`%c🚀 ${appName}: Version ${version} 🚀`, style);
  }, [appName]);
};
